"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Interface;
(function (Interface) {
    Interface["Site"] = "site";
    Interface["Page"] = "page";
    Interface["Zone"] = "zone";
})(Interface = exports.Interface || (exports.Interface = {}));
exports.InterfaceKey = {
    [Interface.Site]: 'INTERFACE.SITE',
    [Interface.Page]: 'INTERFACE.PAGE',
    [Interface.Zone]: 'INTERFACE.ZONE',
};
//# sourceMappingURL=interface.js.map